import {
  BookOpen,
  FileBarChart,
  FileQuestion,
  FileText,
  Globe,
  LibraryBig,
  Mic,
  Newspaper,
  type LucideIcon,
} from "lucide-react";
import type { LibrarySourceType } from "@/lib/library";

/**
 * Single source of truth for the Lucide icon + short noun used for each
 * library source type across the app (My Library summary chips, My Excerpts
 * card pills + filter, SourceCombobox, etc.). Keeps icon parity so users see
 * the same glyph for "Article" everywhere.
 */
export const SOURCE_TYPE_ICON: Record<NonNullable<LibrarySourceType>, LucideIcon> = {
  book: LibraryBig,
  journal_article: Newspaper,
  chapter: BookOpen,
  proceedings_article: FileText,
  website: Globe,
  report: FileBarChart,
  podcast: Mic,
  other: FileQuestion,
};

export const getSourceTypeIcon = (type: LibrarySourceType | null | undefined): LucideIcon =>
  (type && SOURCE_TYPE_ICON[type]) || FileQuestion;

